// extracted by mini-css-extract-plugin
export var option = "_fg-0";
export var optionCard = "_fg-f";
export var optionContent = "_fg-g";
export var optionIcon = "_fg-i";
export var optionIconBox = "_fg-h";
export var optionLabel = "_fg-j";
export var optionPill = "_fg-m";
export var optionPillBadge = "_fg-p";
export var optionPillIcon = "_fg-n";
export var optionPillLabel = "_fg-o";
export var optionRadio = "_fg-k";
export var optionRadioInner = "_fg-l";
export var optionReveal = "_fg-2";
export var optionRevealDelay0 = "_fg-3";
export var optionRevealDelay1 = "_fg-4";
export var optionRevealDelay10 = "_fg-d";
export var optionRevealDelay11 = "_fg-e";
export var optionRevealDelay2 = "_fg-5";
export var optionRevealDelay3 = "_fg-6";
export var optionRevealDelay4 = "_fg-7";
export var optionRevealDelay5 = "_fg-8";
export var optionRevealDelay6 = "_fg-9";
export var optionRevealDelay7 = "_fg-a";
export var optionRevealDelay8 = "_fg-b";
export var optionRevealDelay9 = "_fg-c";
export var optionSelected = "_fg-1";